import React, { useEffect, useState } from 'react'
import api from "../../services/api"

import ReactLoading from 'react-loading';
import { subMonths, format, startOfMonth } from 'date-fns'
import { Modal, ModalDialog } from 'react-bootstrap';
import { Button } from 'reactstrap';
import Draggable from 'react-draggable';


import Swal from 'sweetalert2'

import LOGO_ALL from './../../assets/ImageAll.jpeg'
import IMG_CHIP from './../../assets/img-chip.png'
import IMG_SINAL from './../../assets/sinal.png'
import IMG_ROLAMENTO from './../../assets/rolamento.png'
import IMG_ROLAMENTOSINALEIRO from './../../assets/rolamento-sinaleiro.png'
import IMG_WORDART from './../../assets/wordart.png'

import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";

import { useSelector } from "react-redux";

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Legend } from 'recharts';
import { defaultHeaders } from '../../services/auth';

class DraggableModalDialog extends React.Component {
    render() {
        return <Draggable handle=".modal-header"><ModalDialog {...this.props} /></Draggable>
    }
}

export default function SPM({ showModal, handleCloseModal }) {
    const [loading, setLoading] = useState(false)
    const [processing, setProcessing] = useState(false)
    const [startDate, setStartDate] = useState(format(startOfMonth(subMonths(new Date(), 3)), 'yyyy-MM-dd'))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [clientes, setClientes] = useState([])
    const [equipamentos, setEquipamentos] = useState([])

    const [cliente, setCliente] = useState('')
    const [equipamento, setEquipamento] = useState('')

    const [data, setData] = useState([])
    const [conclusao, setConclusao] = useState('')

    const _login = useSelector((state) => state.login);
    const renderCusomizedLegend = (props) => {
        return (
            <div style={{ display: "flex", justifyContent: "center", marginTop: "20px", position: "absolute", width: "100%" }}>
                <div style={{ display: "flex" }}>
                    <div style={{ background: "#FF9CCD", width: '15px', height: '15px', borderRadius: "50%", marginRight: "5px" }}></div>
                    <span>DBC</span>
                </div>
                <div style={{ display: "flex", marginLeft: "15px" }}>
                    <div style={{ background: "#00CCFF", width: '15px', height: '15px', borderRadius: "50%", marginRight: "5px" }}></div>
                    <span>DBM</span>
                </div>

                <div style={{ display: "flex", marginLeft: "15px" }}>
                    <div style={{ background: "#FF0000", width: '15px', height: '15px', borderRadius: "50%", marginRight: "5px" }}></div>
                    <span>Max. DBC</span>
                </div>
                <div style={{ display: "flex", marginLeft: "15px" }}>
                    <div style={{ background: "#000080", width: '15px', height: '15px', borderRadius: "50%", marginRight: "5px" }}></div>
                    <span>Max. DBM</span>
                </div>
            </div>
        )
    }

    const getEquipamentos = async (id) => {
        setCliente(id)
        await api.post('/os/buscarequipamentos', { "cliente": id }, { headers: defaultHeaders() })
            .then(response => {
                if (response.data.message)
                    setEquipamentos([])
                else
                    setEquipamentos(response.data)
            })
            .catch(error => {
                console.log(error)
            })

    }

    const ClearForm = () => {
        setStartDate(format(startOfMonth(subMonths(new Date(), 3)), 'yyyy-MM-dd'))
        setEndDate(format(new Date(), 'yyyy-MM-dd'))
        setCliente('')
        setEquipamento('')
        setConclusao('')
    }

    const Report = async () => {

        if (cliente === '') {
            Swal.fire({
                title: 'Erro!',
                text: 'Cliente não informado!',
                confirmButtonColor: "#63A8EB",
                icon: 'error',
                confirmButtonText: 'OK'
            })
            return
        }

        if (startDate > endDate) {
            Swal.fire({
                title: 'Erro!',
                text: 'Data inicial não pode ser maior que a data final!',
                confirmButtonColor: "#63A8EB",
                icon: 'error',
                confirmButtonText: 'OK'
            })
            return
        }

        if (equipamento === '') {
            Swal.fire({
                title: 'Erro!',
                text: 'Equipamento não informado!',
                confirmButtonColor: "#63A8EB",
                icon: 'error',
                confirmButtonText: 'OK'
            })
            return
        }

        if (conclusao === '') {
            Swal.fire({
                title: 'Erro!',
                text: 'Conclusão não informado!',
                confirmButtonColor: "#63A8EB",
                icon: 'error',
                confirmButtonText: 'OK'
            })
            return
        }

        setProcessing(true)
        setLoading(true)
        await api.post('/os/buscarmedidoresspm',
            { headers: defaultHeaders() },
            {
                equipamentoid: equipamento,
                inicio: startDate,
                fim: endDate,
                clienteid: cliente
            })
            .then(async (response) => {
                if (response.data.length === 0) {
                    Swal.fire({
                        title: 'Erro!',
                        text: 'Não existe informações a serem apresendadas!',
                        confirmButtonColor: "#63A8EB",
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                    setProcessing(false)
                    setLoading(false)
                } else {
                    if (response.data.message) {
                        Swal.fire({
                            title: 'Atenção!',
                            text: response.data.message,
                            confirmButtonColor: "#63A8EB",
                            icon: 'warning',
                            confirmButtonText: 'OK'
                        })
                        setProcessing(false)
                        setLoading(false)
                    } else {
                        setConclusao(conclusao || 'Podemos concluir que os valores coletados estão dentro dos níveis permissíveis, com exceção dos valores referentes ao rolamento traseiro do motor (LOA), que em 11/03/2019 apresentou nível crítico diante do método e atualmente é perceptível o ruído anormal desse equipamento. Indicamos desacoplar o motor/elemento e encaminhar o motor para assistência autorizada e verificação do elemento pela Coalumaq.')
                        setData(response.data)


                        setTimeout(async () => {
                            const doc = document.getElementById('app').outerHTML;

                            const header = `
                                <style>
                                    @page {
                                        size: auto;   /* auto is the initial value */
                                        margin: 0;  /* this affects the margin in the printer settings */
                                    }
                                    
                                    * {
                                        -webkit-print-color-adjust: exact !important;   /* Chrome, Safari, Edge */
                                        color-adjust: exact !important;                 /*Firefox*/
                                    }
                                    
                                        .recharts-surface {background-image: linear-gradient(to right,#cdffff, #fff); border:1px solid #000; border-radius: 15px;}
                                </style>`

                            var mywindow = window.open('', 'PRINT', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no,height=1,width=1,top=5000,left=5000');
                            mywindow.document.write(header);
                            mywindow.document.write(doc);

                            if (!mywindow || mywindow.closed || typeof mywindow.closed == 'undefined') {
                                Swal.fire({
                                    title: 'Erro!',
                                    text: 'Para visualizar o relatório, você deve autorizar a exibição de popup em seu navegador!',
                                    confirmButtonColor: "#63A8EB",
                                    icon: 'error',
                                    confirmButtonText: 'OK'
                                })
                                return
                            }

                            var pdf = new jsPDF('p', 'mm');
                            var pageWidth = pdf.internal.pageSize.getWidth();


                            await html2canvas(mywindow.document.documentElement.querySelector('#capa'))
                                .then((canvas) => {
                                    var imgData = canvas.toDataURL('image/png');

                                    pdf.addImage(imgData, 'PNG', 2, 0, pageWidth - 4, 0);

                                }).catch(error => {
                                    console.log(error)
                                })

                            await html2canvas(mywindow.document.documentElement.querySelector('#part01'))
                                .then((canvas) => {
                                    var imgData = canvas.toDataURL('image/png');
                                    pdf.addPage('l', 'mm', 'a4');
                                    pdf.addImage(imgData, 'PNG', 2, 0, pageWidth - 4, 0);

                                }).catch(error => {
                                    console.log(error)
                                })

                            for (var i = 0; i < response.data.length - 1; i += 2) {
                                let img01
                                let img02

                                let div = mywindow.document.documentElement.querySelectorAll('.graphic')[i]
                                await html2canvas(div)
                                    .then((canvas) => {
                                        img01 = canvas.toDataURL('image/png');

                                    }).catch(error => {
                                        console.log(error)
                                    })

                                div = mywindow.document.documentElement.querySelectorAll('.graphic')[i + 1]
                                await html2canvas(div)
                                    .then((canvas) => {
                                        img02 = canvas.toDataURL('image/png');

                                    }).catch(error => {
                                        console.log(error)
                                    })

                                pdf.addPage('l', 'mm', 'a4');
                                pdf.addImage(img01, 'PNG', 2, 0, pageWidth - 4, 0)
                                pdf.addImage(img02, 'PNG', 2, 150, pageWidth - 4, 0)
                            }

                            await html2canvas(mywindow.document.documentElement.querySelector('#conclusao'))
                                .then((canvas) => {
                                    var imgData = canvas.toDataURL('image/png');
                                    pdf.addPage('l', 'mm', 'a4');
                                    pdf.addImage(imgData, 'PNG', 2, 0, pageWidth - 4, 0);

                                }).catch(error => {
                                    console.log(error)
                                })

                            mywindow.close();

                            const form = new FormData()

                            form.append('file', pdf.output('blob'))
                            form.append('conclusao', new Date())
                            form.append('equipamentoid', equipamento)
                            form.append('usuarioid', _login.usuarioid)
                            form.append('empresaid', cliente)
                            form.append('dt_ini', startDate)
                            form.append('dt_fin', endDate)

                            await api.post('/os/gravarRelatorioSpm',
                                form,
                                {
                                    headers: {
                                        ...defaultHeaders(),
                                        'Content-Type': 'multipart/form-data'
                                    }
                                })
                                .then(() => {
                                    pdf.save(cliente + '-' + equipamento + '.pdf')
                                    ClearForm()
                                    setProcessing(false)
                                    setLoading(false)
                                })
                                .catch(() => {
                                    setProcessing(false)
                                    setLoading(false)
                                })
                        }, 2000);


                    }
                }

            })
            .catch(error => {
                setProcessing(false)
                setLoading(false)
                console.log('Erro: ' + error)
            })


    }

    useEffect(() => {
        async function callBack() {
            await api.post('/os/buscarclientes', { headers: defaultHeaders() })
                .then(response => {
                    setClientes(response.data)
                })
                .catch(error => {
                    console.log(error)
                })
        }

        callBack();
    }, [])

    useEffect(() => {
        ClearForm()
    }, [showModal])


    let pageAux = 2

    return (
        <>
            <Modal size='sm' show={showModal} onHide={handleCloseModal} animation={true} backdrop="static" modal dialogAs={DraggableModalDialog} dialogClassName="height525">
                <Modal.Header closeButton>
                    <Modal.Title style={{ marginBottom: "0px" }}>
                        <i className="fa fa-chart-line"></i> Geração de Relatório de SPM
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ display: "flex", justifyContent: "center", padding: "10px" }} >
                        <div className={loading ? '' : 'hidden-display'} style={{ justifyContent: "center", width: "568px", height: "348px", display: "flex", alignItems: "center" }}>
                            <ReactLoading type='spin' color='#007bff' height={35} width={35} />
                        </div>

                        <div className={!loading ? '' : 'hidden-display'} style={{ border: "1px solid #cacaca", borderRadius: "5px", padding: "15px", width: '100%', display: 'flex', flexDirection: 'column' }}>
                            <div>
                                <label>Cliente</label>
                                <select className="form-control" value={cliente} onChange={e => getEquipamentos(e.target.value)} required>
                                    <option value="">Selecione</option>
                                    {clientes.map((item) => {
                                        return (<option value={item.CLIENTEID}>{item.NOME} - {item.CNPJ_CPF}</option>)
                                    })}
                                </select>
                            </div>
                            <div>
                                <label>Equipamento</label>
                                <select className="form-control" value={equipamento} onChange={e => setEquipamento(e.target.value)} required>
                                    <option value="">Selecione</option>
                                    {equipamentos.map((item) => {
                                        return (<option value={item.PRODUTOID}>{item.SERIE} - {item.NOME}</option>)
                                    })}
                                </select>
                            </div>
                            <div>
                                <label>Período</label>
                                <div style={{ display: "flex" }}>
                                    <input type="date" className="form-control" value={startDate} onChange={e => setStartDate(e.target.value)} />
                                    <input type="date" className="form-control" style={{ marginLeft: "5px" }} value={endDate} onChange={e => setEndDate(e.target.value)} />
                                </div>
                            </div>
                            <div>
                                <label>Conclusão</label>
                                <div style={{ display: "flex", height: "110px" }}>
                                    <textarea className="form-control" value={conclusao} onChange={e => setConclusao(e.target.value)} required></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-info' disabled={processing} onClick={e => Report()}><i className={`fa ${processing ? 'fa-spinner fa-spin' : 'fa-newspaper'}`}></i> Gerar Relatório</button>
                    <Button className="btn-ligth-gray" onClick={e => ClearForm()}>
                        <em className="fa fa-eraser"></em> Limpar
                    </Button>
                    <Button className="btn-ligth-gray" onClick={e => handleCloseModal()}>
                        <em className="fa fa-window-close"></em> Fechar
                    </Button>
                </Modal.Footer>
            </Modal>


            <div id="app" className='hidden-display'>
                <div id="capa" style={{ width: "880px", height: "1150px" }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <div style={{ justifyContent: "center", display: "flex", marginTop: "180px" }}>
                            <img src={IMG_WORDART} alt="" />
                        </div>
                        <div style={{ fontSize: "32px", fontWeight: "bold", justifyContent: "center", display: "flex" }}>
                            Relatório de SPM - Atlas Copco
                        </div>
                    </div>
                    <div style={{ fontSize: "25px", marginLeft: "35px", marginTop: "90px", alignItems: "center" }}>
                        <div style={{ display: "flex", justifyContent: "left" }}>
                            <span style={{ fontWeight: "bold", marginRight: '5px' }}>EMPRESA: </span><span> {data.length > 0 ? data[0][0].CLIENTE : ''}</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "left", marginTop: "10px" }}>
                            <span style={{ fontWeight: "bold", marginRight: '5px' }}>COMPRESSOR: </span><span> {data.length > 0 ? data[0][0].EQUIPAMENTO : ''}</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "left", marginTop: "10px" }}>
                            <span style={{ fontWeight: "bold", marginRight: '5px' }}>N/S: </span><span> {data.length > 0 ? data[0][0].SERIE : ''}</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "left", marginTop: "10px" }}>
                            <span style={{ fontWeight: "bold", marginRight: '5px' }}>DATA/HORA: </span><span> {format(new Date(), 'dd/MM/yyyy - HH:mm:ss')}</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "90px" }}>
                            <img alt="" src={LOGO_ALL} style={{ width: '400px' }} />
                        </div>
                    </div>
                </div>
                <br />
                <br /><br /><br /><br /><br /><br /><br /><br /><br />
                <div id="part01" style={{ width: "880px", height: "1250px" }}>
                    <div style={{ padding: "40px 40px 0px 30px", fontSize: "16px" }}>
                        <p style={{ fontWeight: 'bold' }}>1. Apresentando a Metodologia SPM (Método de Pulso de Choques) de Análise de Rolamentos</p>
                        <div>
                            <div style={{ width: "75%", float: "left" }}>
                                <p>O alvo primordial do SPM são os rolamentos (danos mecânicos e lubrificação). Em muitas aplicações, estes são os únicos componentes que precisam ser monitorados.</p>
                                <p>O método reage ainda ao desalinhamento de eixos, a cavitação em bombas e as falhas de mentagem  como pré-carga excessiva, danos no engrenamento, etc. A avaliação está baseada nas investigações da SPM e é possível monitorar qualquer classe de rolamentos.</p>
                            </div>
                            <div style={{ textAlign: "right" }}>
                                <img src={IMG_CHIP} style={{ width: "20%" }} alt="" />
                            </div>
                        </div>
                        <p style={{ fontWeight: 'bold', marginTop: "-60px" }}>Processamento do Sinal SPM</p>
                        <div>
                            <div style={{ textAlign: "left", float: "left", marginRight: "15px" }}>
                                <img src={IMG_SINAL} alt="" />
                            </div>
                            <div style={{ width: "75%" }}>
                                <p>O transdutor SPM é um acelerômetro Piezelétrico. Quando tocado por uma onda de choque ele responde com sua própria freqüência de ressonância de 32 Khz.</p>
                            </div>
                        </div>
                        <p style={{ marginTop: "50px" }}>O transdutor amplifica a alta freqüência do sinal de choque e filtra todas as outras vibrações da máquina. Na saída do transdutor, lê-se uma rápida seqüência de pulsos elétricos proporcionais as amplitudes das ondas de choque.</p>
                        <p style={{ fontWeight: 'bold' }}>Leitura de Pulsos de Choque – SPM</p>
                        <p>Os pulsos de choque são medidos numa escala de decibéis, chamada dBsv = Decibel Shock Value.<br />
                            O nível de choques do rolamento é uma função da sua velocidade rolante e da sua condição. O cálculo de um valor inicial dBi (Decibel inicial), retira a velocidade do contexto da avaliação, deixando a condição como única variável responsável pela elevação dos sinais. O valor dBc ou Carpet Value está ligado a condição de lubrificação do rolamento, enquanto o valor dBm (Decibel Maximun) determina a sua condição mecânica.
                        </p>
                        <p>Para neutralizar o efeito da velocidade rolante, um instrumento SPM deve ser programado com:</p>
                        <div>
                            <div style={{ width: "50%", float: "left" }}>
                                <p style={{ marginTop: "75px" }}>a) Diâmetro de eixo em mm ou polegadas e;<br />
                                    b) Velocidade rotacional em r.p.m.
                                </p>
                            </div>
                            <div style={{ textAlign: "right", width: "100%" }}>
                                <img src={IMG_ROLAMENTO} alt="" />
                            </div>
                        </div>
                        <p style={{ fontWeight: 'bold' }}>O Nível de Choque como função da condição de um rolamento</p>
                        <div>
                            <div style={{ textAlign: "left", float: "left", marginRight: "15px" }}>
                                <img src={IMG_ROLAMENTOSINALEIRO} style={{ width: "75%" }} alt="" />
                            </div>
                            <div style={{ width: "100%" }}>
                                <p>1) Em rolamentos bons os valores de dBc e de dBm devem estar na faixa verde da escala de condição e com uma pequena diferença entre eles.<br />
                                    2) Um rolamento rodando a seco, terá o seu padrão de sinais aumentado, mas neste caso, a diferença entre dBc e dBm normalmente será pequena.<br />
                                    3) Carracteristicamente os rolamentos danificados têm um alto valor de dBm e uma grande diferença (delta) entre dBm e dBc.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: 'flex-end', marginTop: "230px", marginRight: "45px" }}>
                        Página {pageAux}
                    </div>
                </div>


                {data.map((item, key) => {
                    pageAux += 0.5
                    return (
                        <div style={{ width: "880px", padding: "40px 40px 40px 30px" }} className="graphic">
                            {key === 0 &&
                                <div style={{ padding: "10px" }}>
                                    <p style={{ fontWeight: 'bold' }}>2. Gráficos dBm e dBc</p>
                                </div>
                            }
                            <div style={{ padding: "10px", margin: "12px 0px" }}>
                                <h3>{`Ponto de Medição: ${item[0].GRUPO_MEDIDOR}`}</h3>
                                <LineChart width={820} height={460} data={item} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                    <XAxis dataKey="DATA_MEDICAO" angle={330} tickMargin={3} />
                                    <YAxis dataKey="VALOR_DBM" />
                                    <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                                    <Line type="monotone" dataKey="VALOR_DBC" stroke="#FF9CCD" strokeWidth={2} />
                                    <Line type="monotone" dataKey="VALOR_DBM" stroke="#00CCFF" strokeWidth={2} />
                                    <Line type="monotone" dataKey="VALOR_DBC_MAX" stroke="#FF0000" strokeWidth={3} />
                                    <Line type="monotone" dataKey="VALOR_DBM_MAX" stroke="#000080" strokeWidth={3} />
                                    <Legend verticalAlign="bottom" align="right" layout="horizontal" content={renderCusomizedLegend} />
                                </LineChart>
                            </div>
                            {key % 2 !== 0 &&
                                <div style={{ display: "flex", justifyContent: 'flex-end', marginTop: "0px", marginRight: "45px" }}>
                                    Página {pageAux}
                                </div>
                            }
                        </div>

                    )

                })}

                <br />

                <div id="conclusao" style={{ width: "880px", height: "1250px", padding: "10px", display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
                    <div>
                        <div style={{ padding: "10px" }}>
                            <p style={{ fontWeight: 'bold' }}>3. Conclusão</p>
                        </div>
                        <p style={{ padding: "0px 10px 10px 10px", marginTop: "-10px" }}>
                            {conclusao}
                        </p>
                    </div>

                    <div style={{ marginRight: "65px", textAlign: 'end' }}>
                        Página {pageAux + 1}
                    </div>
                </div>
            </div>
        </>
    )
}